export default __webpack_public_path__ + "static/featured-properties-img1-94996cc2bb4632a03dbf8f5d5d264d9d.jpg";